import * as i0 from '@angular/core';
import { input, HostBinding, Inject, ChangeDetectionStrategy, Component, computed, model, InjectionToken, inject, signal, output, contentChild, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, NgClass, AsyncPipe, NgTemplateOutlet } from '@angular/common';
import * as i4 from '@noda-lib/utils/pipes';
import { EqualPipe, ConditionPipe, DefinedPipe, MapPipe, RangePipe } from '@noda-lib/utils/pipes';
import * as i8 from '@taiga-ui/kit';
import { TuiBadge, TuiStatus, TuiChip, TuiCheckbox, TuiButtonLoading, TuiFiles, TuiProgress, TuiSliderComponent } from '@taiga-ui/kit';
import { ASSETS_CDN_URL } from '@noda-lib/assets/root';
import * as i4$1 from '@angular/forms';
import { FormsModule, NgControl } from '@angular/forms';
import * as i1$1 from '@taiga-ui/core';
import { TuiOption, TuiButton, TuiNotification } from '@taiga-ui/core';
import { provideFormControl, provideControlValidator } from '@noda-lib/assets/tools';
import { wrapToArray } from '@noda-lib/utils/handlers';
import * as i3 from '@noda-lib/utils/directives';
import { DownloadDirective } from '@noda-lib/utils/directives';
import * as i7 from '@taiga-ui/cdk/directives/item';
import { __decorate } from 'tslib';
import { Bind } from '@noda-lib/utils/decorators';
import { tuiClamp } from '@taiga-ui/cdk';
function BadgeComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "assets-icon", 3);
    i0.ɵɵpipe(1, "equal");
    i0.ɵɵpipe(2, "equal");
    i0.ɵɵpipe(3, "condition");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("badge-icon--s", i0.ɵɵpipeBind2(1, 3, ctx_r0.size(), "s"));
    i0.ɵɵproperty("icon", i0.ɵɵpipeBind3(3, 9, i0.ɵɵpipeBind2(2, 6, ctx_r0.type(), "status"), "dote", ctx_r0.icon()));
  }
}
const _c0 = ["*"];
function ChipComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "assets-icon", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r0.iconLeft());
  }
}
function ChipComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "assets-icon", 2);
  }
}
function ChipComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "assets-icon", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r0.iconRight());
  }
}
function DropdownItemComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "assets-icon", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const iconSize_r3 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("icon", ctx_r1.iconLeft())("size", iconSize_r3);
  }
}
function DropdownItemComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.caption(), " ");
  }
}
function DropdownItemComponent_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.description(), " ");
  }
}
function DropdownItemComponent_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "p", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.rightText(), " ");
  }
}
function DropdownItemComponent_Conditional_20_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "assets-badge", 14);
  }
  if (rf & 2) {
    const tag_r4 = ctx.$implicit;
    i0.ɵɵnextContext(2);
    const badgeSize_r5 = i0.ɵɵreadContextLet(6);
    i0.ɵɵproperty("appearance", tag_r4.appearance)("size", badgeSize_r5)("type", tag_r4.type)("value", tag_r4.value);
  }
}
function DropdownItemComponent_Conditional_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵrepeaterCreate(1, DropdownItemComponent_Conditional_20_For_2_Template, 1, 4, "assets-badge", 14, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.tags());
  }
}
function DropdownItemComponent_Conditional_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "assets-badge", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const badgeSize_r5 = i0.ɵɵreadContextLet(6);
    i0.ɵɵproperty("appearance", ctx_r1.counter().appearance)("size", badgeSize_r5)("value", ctx_r1.counter().value);
  }
}
function DropdownItemComponent_Conditional_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "assets-icon", 12);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const iconSize_r3 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("icon", ctx_r1.iconRight())("size", iconSize_r3);
  }
}
function FileInputComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.subtitle(), " ");
  }
}
function FileInputComponent_Conditional_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FileInputComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 5);
    i0.ɵɵtemplate(1, FileInputComponent_Conditional_8_ng_container_1_Template, 1, 0, "ng-container", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.subtitleTpl());
  }
}
function FileInputComponent_For_15_tui_file_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵpipe(1, "map");
    i0.ɵɵelement(2, "assets-icon", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const file_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngDownload", i0.ɵɵpipeBind2(1, 4, file_r4, ctx_r1.getFileSource))("ngDownloadName", file_r4.name)("ngDownloadType", "url");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("size", 20);
  }
}
function FileInputComponent_For_15_tui_file_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-file", 14);
    i0.ɵɵpipe(1, "condition");
    i0.ɵɵpipe(2, "condition");
    i0.ɵɵlistener("remove", function FileInputComponent_For_15_tui_file_0_Template_tui_file_remove_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const file_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRemove(file_r4));
    });
    i0.ɵɵconditionalCreate(3, FileInputComponent_For_15_tui_file_0_Conditional_3_Template, 3, 7, "button", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const file_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("file", file_r4)("showDelete", i0.ɵɵpipeBind3(1, 4, ctx_r1.editable(), "always", false))("state", i0.ɵɵpipeBind3(2, 8, ctx_r1.loading(), "loading", "normal"));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.downloadable() && !ctx_r1.editable() ? 3 : -1);
  }
}
function FileInputComponent_For_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FileInputComponent_For_15_tui_file_0_Template, 4, 12, "tui-file", 13);
  }
}
function FileInputComponent_For_17_tui_file_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-file", 18);
    i0.ɵɵpipe(1, "tuiFileRejected");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("remove", function FileInputComponent_For_17_tui_file_0_Template_tui_file_remove_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const file_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRemoveRejectedFile(file_r6));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const file_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext();
    const validator_r7 = i0.ɵɵreference(12);
    i0.ɵɵproperty("file", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind2(1, 1, file_r6, validator_r7)) || file_r6);
  }
}
function FileInputComponent_For_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FileInputComponent_For_17_tui_file_0_Template, 3, 6, "tui-file", 17);
  }
}
const _c1 = [[["title"]], [["info"]], [["additional"]]];
const _c2 = ["title", "info", "additional"];
function NotificationComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "assets-icon", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r0.icon())("size", ctx_r0.iconSize());
  }
}
function NotificationComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function NotificationComponent_Conditional_10_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onCloseClick($event));
    });
    i0.ɵɵelement(1, "assets-icon", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", 20);
  }
}
const _c3 = [[["labelLeft"]], [["labelRight"]], [["bottomLeft"]], [["bottomMid"]], [["bottomRight"]]];
const _c4 = ["labelLeft", "labelRight", "bottomLeft", "bottomMid", "bottomRight"];
function SliderWrapperComponent_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SliderWrapperComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SliderWrapperComponent_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const button_r2 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", button_r2)("ngTemplateOutletContext", ctx_r0.decreaseContext);
  }
}
function SliderWrapperComponent_Conditional_4_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function SliderWrapperComponent_Conditional_4_For_2_Template_button_click_0_listener() {
      const $index_r4 = i0.ɵɵrestoreView(_r3).$index;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.setValueByIndex($index_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "map");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const $index_r4 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r0.isControlDisabled());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 2, $index_r4, ctx_r0.stepLabelFn()), " ");
  }
}
function SliderWrapperComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵrepeaterCreate(1, SliderWrapperComponent_Conditional_4_For_2_Template, 3, 5, "button", 5, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵpipe(3, "range");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(i0.ɵɵpipeBind2(3, 0, ctx_r0.labelsSize(), 0));
  }
}
function SliderWrapperComponent_Conditional_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SliderWrapperComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SliderWrapperComponent_Conditional_5_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const button_r2 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", button_r2)("ngTemplateOutletContext", ctx_r0.increaseContext);
  }
}
function SliderWrapperComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function SliderWrapperComponent_ng_template_6_Template_button_click_0_listener() {
      const actionType_r6 = i0.ɵɵrestoreView(_r5).actionType;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.changeValue(actionType_r6));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const icon_r7 = ctx.icon;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r0.isControlDisabled())("iconStart", icon_r7);
  }
}
function TagComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function TagComponent_Conditional_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClickEmitter($event));
    });
    i0.ɵɵelement(1, "assets-icon", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r1.icon())("size", 16);
  }
}
let IconComponent = /*#__PURE__*/(() => {
  class IconComponent {
    constructor(cdn) {
      this.cdn = cdn;
      this.size = input(null);
      this.icon = input.required();
    }
    get iconSize() {
      return this.size();
    }
    get iconUrl() {
      return `url(${this.cdn}/storage/projects/assets-lib/icons/${this.icon()}.svg)`;
    }
    static {
      this.ɵfac = function IconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IconComponent)(i0.ɵɵdirectiveInject(ASSETS_CDN_URL));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IconComponent,
        selectors: [["assets-icon"]],
        hostVars: 4,
        hostBindings: function IconComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("--assets-icon-component-size", ctx.iconSize, "px")("--assets-icon-url", ctx.iconUrl);
          }
        },
        inputs: {
          size: [1, "size"],
          icon: [1, "icon"]
        },
        decls: 1,
        vars: 0,
        consts: [[1, "assets-icon"]],
        template: function IconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
          }
        },
        styles: ["[_nghost-%COMP%]{--assets-icon-component-size: 24px;display:inline-flex}[_nghost-%COMP%]   .assets-icon[_ngcontent-%COMP%]{width:var(--assets-icon-component-size);height:var(--assets-icon-component-size);background-color:currentcolor;background-size:cover;-webkit-mask-image:var(--assets-icon-url);mask-image:var(--assets-icon-url);-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-size:contain;mask-size:contain}"],
        changeDetection: 0
      });
    }
  }
  return IconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const BadgeImports = [CommonModule, TuiBadge, IconComponent, TuiStatus, EqualPipe, ConditionPipe];
let BadgeComponent = /*#__PURE__*/(() => {
  class BadgeComponent {
    constructor() {
      this.value = input.required();
      this.type = input(null);
      this.icon = input(null);
      this.appearance = input('default');
      this.size = input('l');
      this.withIcon = computed(() => {
        return this.type() === 'icon' || this.type() === 'status';
      });
    }
    static {
      this.ɵfac = function BadgeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BadgeComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BadgeComponent,
        selectors: [["assets-badge"]],
        inputs: {
          value: [1, "value"],
          type: [1, "type"],
          icon: [1, "icon"],
          appearance: [1, "appearance"],
          size: [1, "size"]
        },
        decls: 4,
        vars: 4,
        consts: [[1, "badge", 3, "size"], [1, "badge-icon", 3, "badge-icon--s", "icon"], [1, "badge-text"], [1, "badge-icon", 3, "icon"]],
        template: function BadgeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "tui-badge", 0);
            i0.ɵɵconditionalCreate(1, BadgeComponent_Conditional_1_Template, 4, 13, "assets-icon", 1);
            i0.ɵɵelementStart(2, "span", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("size", ctx.size());
            i0.ɵɵattribute("data-type", ctx.appearance());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.withIcon() ? 1 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.value(), " ");
          }
        },
        dependencies: [i1.CommonModule, i8.TuiBadge, IconComponent, i4.EqualPipe, i4.ConditionPipe],
        styles: ["[_nghost-%COMP%]{display:inline-block;height:fit-content}.badge[data-type=default][_ngcontent-%COMP%]{color:var(--assets-base-stable-white);background-color:var(--assets-primary)}.badge[data-type=default][_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{color:var(--assets-base-stable-white)}.badge[data-type=accent][_ngcontent-%COMP%]{color:var(--assets-base-stable-white);background-color:var(--assets-accent)}.badge[data-type=accent][_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{color:var(--assets-base-stable-white)}.badge[data-type=success][_ngcontent-%COMP%]{color:var(--assets-text-01);background-color:var(--assets-success-bg)}.badge[data-type=success][_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{color:var(--assets-success-fill)}.badge[data-type=error][_ngcontent-%COMP%]{color:var(--assets-text-01);background-color:var(--assets-error-bg)}.badge[data-type=error][_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{color:var(--assets-error-fill)}.badge[data-type=info][_ngcontent-%COMP%]{color:var(--assets-text-01);background-color:var(--assets-info-bg)}.badge[data-type=info][_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{color:var(--assets-info-fill)}.badge[data-type=warning][_ngcontent-%COMP%]{color:var(--assets-text-01);background-color:var(--assets-warning-bg)}.badge[data-type=warning][_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{color:var(--assets-warning-fill)}.badge[data-type=additional][_ngcontent-%COMP%]{color:var(--assets-text-01);background-color:var(--assets-additional-bg)}.badge[data-type=additional][_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{color:var(--assets-additional-fill)}.badge[data-type=clear][_ngcontent-%COMP%]{color:var(--assets-text-01);background-color:var(--assets-neutral-bg)}.badge[data-type=clear][_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{color:var(--assets-neutral-fill)}.badge[data-size=xl][_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%], .badge[data-size=l][_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{--assets-icon-component-size: 16px}.badge[data-size=m][_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%], .badge[data-size=s][_ngcontent-%COMP%]   .badge-icon[_ngcontent-%COMP%]{--assets-icon-component-size: 12px}"],
        changeDetection: 0
      });
    }
  }
  return BadgeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ChipImports = [TuiChip, IconComponent, DefinedPipe, NgClass, EqualPipe, FormsModule];
let ChipComponent = /*#__PURE__*/(() => {
  class ChipComponent {
    constructor() {
      this.text = input.required();
      this.fill = input('outline');
      this.status = input(null);
      this.size = input('m');
      this.iconLeft = input(null);
      this.iconRight = input(null);
      this.disabled = input(false);
      this.checked = model(false);
    }
    static {
      this.ɵfac = function ChipComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ChipComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ChipComponent,
        selectors: [["assets-chip"]],
        inputs: {
          text: [1, "text"],
          fill: [1, "fill"],
          status: [1, "status"],
          size: [1, "size"],
          iconLeft: [1, "iconLeft"],
          iconRight: [1, "iconRight"],
          disabled: [1, "disabled"],
          checked: [1, "checked"]
        },
        outputs: {
          checked: "checkedChange"
        },
        ngContentSelectors: _c0,
        decls: 9,
        vars: 15,
        consts: [["tuiChip", "", 3, "size"], [3, "icon"], ["icon", "dote", 1, "assets-chip-status-icon"], ["appearance", "outline", "tuiChip", "", "type", "checkbox", 3, "ngModelChange", "disabled", "ngModel"]],
        template: function ChipComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "label", 0);
            i0.ɵɵpipe(1, "defined");
            i0.ɵɵconditionalCreate(2, ChipComponent_Conditional_2_Template, 1, 1, "assets-icon", 1);
            i0.ɵɵconditionalCreate(3, ChipComponent_Conditional_3_Template, 1, 0, "assets-icon", 2);
            i0.ɵɵprojection(4);
            i0.ɵɵelementStart(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(7, ChipComponent_Conditional_7_Template, 1, 1, "assets-icon", 1);
            i0.ɵɵelementStart(8, "input", 3);
            i0.ɵɵtwoWayListener("ngModelChange", function ChipComponent_Template_input_ngModelChange_8_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.checked, $event) || (ctx.checked = $event);
              return $event;
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("assets-chip-status", i0.ɵɵpipeBind1(1, 13, ctx.status()))("disabled", ctx.disabled());
            i0.ɵɵproperty("size", ctx.size());
            i0.ɵɵattribute("data-fill", ctx.fill())("data-status", ctx.status());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.iconLeft() ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.status() ? 3 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.text());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.iconRight() ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.disabled());
            i0.ɵɵtwoWayProperty("ngModel", ctx.checked);
          }
        },
        dependencies: [i8.TuiChip, IconComponent, i4.DefinedPipe, i4$1.FormsModule, i4$1.CheckboxControlValueAccessor, i4$1.NgControlStatus, i4$1.NgModel],
        styles: ["[tuiChip][_ngcontent-%COMP%]{--t-margin: unset !important;color:var(--assets-text-01)!important;box-shadow:unset!important}[tuiChip][_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{pointer-events:none}[tuiChip][_ngcontent-%COMP%]     tui-avatar{margin-inline-start:unset!important}[tuiChip].disabled[_ngcontent-%COMP%]{cursor:default}[tuiChip][_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{line-height:normal}[tuiChip][data-size=m][_ngcontent-%COMP%]{--t-padding: 0 12px !important;--t-gap: 8px !important;border-radius:6px;font:var(--assets-font-text-l)!important}[tuiChip][data-size=m][_ngcontent-%COMP%]   assets-icon[_ngcontent-%COMP%]{--assets-icon-component-size: 24px}[tuiChip][data-size=s][_ngcontent-%COMP%]{--t-padding: 0 8px !important;--t-gap: 6px !important;border-radius:6px;font:var(--assets-font-text-m)!important}[tuiChip][data-size=s][_ngcontent-%COMP%]   assets-icon[_ngcontent-%COMP%]{--assets-icon-component-size: 20px}.assets-chip-status[data-size=m][_ngcontent-%COMP%]   .assets-chip-status-icon[_ngcontent-%COMP%]{--assets-icon-component-size: 20px;margin-right:-4px}.assets-chip-status[data-size=s][_ngcontent-%COMP%]   .assets-chip-status-icon[_ngcontent-%COMP%]{--assets-icon-component-size: 16px;margin-right:-3px}.assets-chip-status[data-status=success][_ngcontent-%COMP%]   .assets-chip-status-icon[_ngcontent-%COMP%]{color:var(--assets-success-fill)}.assets-chip-status[data-status=error][_ngcontent-%COMP%]   .assets-chip-status-icon[_ngcontent-%COMP%]{color:var(--assets-error-fill)}.assets-chip-status[data-status=info][_ngcontent-%COMP%]   .assets-chip-status-icon[_ngcontent-%COMP%]{color:var(--assets-info-fill)}.assets-chip-status[data-status=warning][_ngcontent-%COMP%]   .assets-chip-status-icon[_ngcontent-%COMP%]{color:var(--assets-warning-fill)}.assets-chip-status[data-status=additional][_ngcontent-%COMP%]   .assets-chip-status-icon[_ngcontent-%COMP%]{color:var(--assets-additional-fill)}.assets-chip-status[data-status=neutral][_ngcontent-%COMP%]   .assets-chip-status-icon[_ngcontent-%COMP%]{color:var(--assets-neutral-fill)}[data-fill=outline][_ngcontent-%COMP%], [data-fill=outline-accent][_ngcontent-%COMP%]{background-color:var(--assets-base-02)!important;border:1px solid var(--assets-base-04)!important}[data-fill=outline][_ngcontent-%COMP%] > input[_ngcontent-%COMP%]:hover:not(:disabled), [data-fill=outline-accent][_ngcontent-%COMP%] > input[_ngcontent-%COMP%]:hover:not(:disabled){background-color:var(--assets-base-03)!important}[data-fill=outline][_ngcontent-%COMP%]:has(input:checked){border:1px solid var(--assets-link)!important}[data-fill=outline-accent][_ngcontent-%COMP%]:has(input:checked){border:1px solid var(--assets-accent)!important}[data-fill=primary][_ngcontent-%COMP%] > input[_ngcontent-%COMP%]:checked, [data-fill=accent][_ngcontent-%COMP%] > input[_ngcontent-%COMP%]:checked{border:none!important}[data-fill=primary][_ngcontent-%COMP%], [data-fill=accent][_ngcontent-%COMP%]{background-color:var(--assets-base-02)!important;border:1px solid var(--assets-base-04)!important}[data-fill=primary][_ngcontent-%COMP%] > input[_ngcontent-%COMP%]:not(:checked):hover:not(:disabled), [data-fill=accent][_ngcontent-%COMP%] > input[_ngcontent-%COMP%]:not(:checked):hover:not(:disabled){background-color:var(--assets-base-03)!important}[data-fill=primary][_ngcontent-%COMP%]:has(input:checked){background-color:var(--assets-primary)!important}[data-fill=accent][_ngcontent-%COMP%]:has(input:checked){background-color:var(--assets-accent)!important}[data-fill=primary][_ngcontent-%COMP%]:has(input:checked), [data-fill=accent][_ngcontent-%COMP%]:has(input:checked){color:var(--assets-base-stable-white)!important}"],
        changeDetection: 0
      });
    }
  }
  return ChipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DropdownItemImports = [FormsModule, TuiCheckbox, TuiOption, IconComponent, BadgeComponent, EqualPipe, ConditionPipe];
let DropdownItemComponent = /*#__PURE__*/(() => {
  class DropdownItemComponent {
    constructor() {
      this.label = input.required();
      this.caption = input(null);
      this.description = input(null);
      this.rightText = input(null);
      this.tags = input(null);
      this.counter = input(null);
      this.iconLeft = input(null);
      this.iconRight = input(null);
      this.size = input('l');
      this.checked = model(false);
    }
    static {
      this.ɵfac = function DropdownItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DropdownItemComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DropdownItemComponent,
        selectors: [["assets-dropdown-item"]],
        inputs: {
          label: [1, "label"],
          caption: [1, "caption"],
          description: [1, "description"],
          rightText: [1, "rightText"],
          tags: [1, "tags"],
          counter: [1, "counter"],
          iconLeft: [1, "iconLeft"],
          iconRight: [1, "iconRight"],
          size: [1, "size"],
          checked: [1, "checked"]
        },
        outputs: {
          checked: "checkedChange"
        },
        decls: 23,
        vars: 34,
        consts: [["tuiOption", "", 1, "dropdown-item"], ["tuiCheckbox", "", "type", "checkbox", 1, "dropdown-item-checkbox", 3, "ngModelChange", "size", "ngModel"], [3, "icon", "size"], [1, "dropdown-item-content"], [1, "dropdown-item-content-text"], [1, "dropdown-item-content-text-left"], [1, "dropdown-item-content-text-left-caption"], [1, "dropdown-item-content-text-left-label"], [1, "dropdown-item-content-text-left-description"], [1, "dropdown-item-content-text-right"], [1, "dropdown-item-content-tags"], [3, "appearance", "size", "value"], [1, "dropdown-item-icon", 3, "icon", "size"], [1, "dropdown-item-content-text-right-description"], [3, "appearance", "size", "type", "value"]],
        template: function DropdownItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵdeclareLet(0);
            i0.ɵɵpipe(1, "equal");
            i0.ɵɵpipe(2, "condition");
            i0.ɵɵdeclareLet(3);
            i0.ɵɵpipe(4, "equal");
            i0.ɵɵpipe(5, "condition");
            i0.ɵɵdeclareLet(6);
            i0.ɵɵpipe(7, "equal");
            i0.ɵɵpipe(8, "condition");
            i0.ɵɵelementStart(9, "div", 0)(10, "input", 1);
            i0.ɵɵtwoWayListener("ngModelChange", function DropdownItemComponent_Template_input_ngModelChange_10_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.checked, $event) || (ctx.checked = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(11, DropdownItemComponent_Conditional_11_Template, 1, 2, "assets-icon", 2);
            i0.ɵɵelementStart(12, "div", 3)(13, "div", 4)(14, "div", 5);
            i0.ɵɵconditionalCreate(15, DropdownItemComponent_Conditional_15_Template, 2, 1, "h5", 6);
            i0.ɵɵelementStart(16, "span", 7);
            i0.ɵɵtext(17);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(18, DropdownItemComponent_Conditional_18_Template, 2, 1, "p", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(19, DropdownItemComponent_Conditional_19_Template, 3, 1, "div", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(20, DropdownItemComponent_Conditional_20_Template, 3, 0, "div", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(21, DropdownItemComponent_Conditional_21_Template, 1, 3, "assets-badge", 11);
            i0.ɵɵconditionalCreate(22, DropdownItemComponent_Conditional_22_Template, 1, 2, "assets-icon", 12);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_11_0;
            i0.ɵɵstoreLet(i0.ɵɵpipeBind3(2, 14, i0.ɵɵpipeBind2(1, 11, ctx.size(), "s"), 16, 24));
            const checkboxSize_r6 = i0.ɵɵpipeBind3(5, 22, i0.ɵɵpipeBind2(4, 19, ctx.size(), "s"), "s", "m");
            i0.ɵɵadvance(6);
            i0.ɵɵstoreLet(i0.ɵɵpipeBind3(8, 29, i0.ɵɵpipeBind2(7, 26, ctx.size(), "s"), "m", "l"));
            i0.ɵɵadvance(3);
            i0.ɵɵattribute("data-size", ctx.size());
            i0.ɵɵadvance();
            i0.ɵɵproperty("size", checkboxSize_r6);
            i0.ɵɵtwoWayProperty("ngModel", ctx.checked);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.iconLeft() ? 11 : -1);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.caption() ? 15 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.label());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.description() ? 18 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.rightText() ? 19 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(((tmp_11_0 = ctx.tags()) == null ? null : tmp_11_0.length) ? 20 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.counter() ? 21 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.iconRight() ? 22 : -1);
          }
        },
        dependencies: [i4$1.FormsModule, i4$1.CheckboxControlValueAccessor, i4$1.NgControlStatus, i4$1.NgModel, i8.TuiCheckbox, IconComponent, BadgeComponent, i4.EqualPipe, i4.ConditionPipe],
        styles: ["[_nghost-%COMP%]{display:inline-block;max-width:320px}.dropdown-item[_ngcontent-%COMP%]{display:flex;gap:10px;align-items:center}.dropdown-item[data-size=l][_ngcontent-%COMP%]{padding:7px 8px!important}.dropdown-item[data-size=m][_ngcontent-%COMP%]{padding:7px 4px!important}.dropdown-item[data-size=s][_ngcontent-%COMP%]{padding:7px 2px!important}.dropdown-item[data-size][_ngcontent-%COMP%]   .dropdown-item-content-text-left-caption[_ngcontent-%COMP%], .dropdown-item[data-size][_ngcontent-%COMP%]   .dropdown-item-content-text-left-description[_ngcontent-%COMP%]{font:var(--assets-font-text-s)!important}.dropdown-item[data-size=l][_ngcontent-%COMP%]   .dropdown-item-content-text-left-label[_ngcontent-%COMP%], .dropdown-item[data-size=l][_ngcontent-%COMP%]   .dropdown-item-content-text-right-description[_ngcontent-%COMP%], .dropdown-item[data-size=m][_ngcontent-%COMP%]   .dropdown-item-content-text-left-label[_ngcontent-%COMP%], .dropdown-item[data-size=m][_ngcontent-%COMP%]   .dropdown-item-content-text-right-description[_ngcontent-%COMP%]{font:var(--assets-font-text-m)!important}.dropdown-item[data-size=s][_ngcontent-%COMP%]   .dropdown-item-content-text-left-label[_ngcontent-%COMP%], .dropdown-item[data-size=s][_ngcontent-%COMP%]   .dropdown-item-content-text-right-description[_ngcontent-%COMP%]{font:var(--assets-font-text-s)!important}.dropdown-item-content-text[_ngcontent-%COMP%]{display:flex;gap:10px;justify-content:space-between}.dropdown-item-content-text-left[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:4px}.dropdown-item-content-text-left-caption[_ngcontent-%COMP%], .dropdown-item-content-text-left-description[_ngcontent-%COMP%]{color:var(--assets-base-07)}.dropdown-item-content-text-right[_ngcontent-%COMP%]{align-self:end}.dropdown-item-content-tags[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;gap:4px;margin-top:4px}.dropdown-item-icon[_ngcontent-%COMP%]{cursor:pointer;color:var(--assets-base-06)}"],
        changeDetection: 0
      });
    }
  }
  return DropdownItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const FileInputImports = [AsyncPipe, ConditionPipe, DownloadDirective, FormsModule, IconComponent, MapPipe, TuiButton, TuiButtonLoading, NgTemplateOutlet, ...TuiFiles];
const FILE_REJECTION_REASONS = new InjectionToken('FILE_REJECTION_REASONS', {
  providedIn: 'root',
  factory: () => ({
    maxFilesRejectionReason: maxFiles => `Error: maximum limit - ${maxFiles} files for upload.`
  })
});
let FileInputComponent = /*#__PURE__*/(() => {
  class FileInputComponent {
    constructor() {
      this.rejectionReasons = inject(FILE_REJECTION_REASONS);
      this.files = signal([]);
      this.rejectedFiles = signal([]);
      this.disabled = signal(false);
      this.isInputHidden = computed(() => {
        const hasMaxAmountOfFiles = this.files().length + this.rejectedFiles().length >= this.maxLength();
        return !this.editable() || hasMaxAmountOfFiles;
      });
      this.title = input.required();
      this.accept = input('.csv,.pdf,.zip,.jpg,.png,.jpeg,.svg,.doc,.docx');
      this.downloadable = input(false);
      this.editable = input(true);
      this.isRequired = input(false);
      this.loading = input(false);
      this.multiple = input(false);
      this.maxFileSize = input(50000000);
      this.maxLength = input(1);
      this.maxVisible = input(3);
      this.mode = input('default');
      this.size = input('m');
      this.subtitle = input(null);
      this.subtitleTpl = input(null);
      this.removeHandler = input(null);
      this.reject = output();
      this.onChange = () => {};
      this.onTouched = () => {};
    }
    writeValue(value) {
      this.files.set(value || []);
    }
    registerOnChange(cb) {
      this.onChange = cb;
    }
    registerOnTouched(cb) {
      this.onTouched = cb;
    }
    validate() {
      const hasNoFiles = this.files().length + this.rejectedFiles().length === 0;
      const hasRejectedFiles = this.rejectedFiles().length > 0;
      if (hasRejectedFiles) {
        return {
          invalidFiles: true
        };
      }
      if (hasNoFiles && this.isRequired()) {
        return {
          required: true
        };
      }
      return null;
    }
    registerOnValidatorChange(cb) {
      this.onValidatorChange = cb;
    }
    setDisabledState(isDisabled) {
      this.disabled.set(isDisabled);
    }
    removeFile(file) {
      this.files.update(files => files.filter(f => f !== file));
      this.onChange(this.files());
    }
    getFileSource(file) {
      return file instanceof File ? file : file.src;
    }
    onFileChange(value) {
      const filesArray = wrapToArray(value);
      const acceptedFiles = this.getAcceptedFiles(filesArray);
      this.makeRejectedFiles(filesArray);
      this.files.set(acceptedFiles);
      this.onChange(this.files());
    }
    updateFiles(newRejectedFiles) {
      this.rejectedFiles.update(rejectedFiles => Array.from(new Set(rejectedFiles.concat(newRejectedFiles))));
      this.files.update(files => this.getAcceptedFiles(files));
    }
    onReject(rejectedFiles) {
      this.updateFiles(rejectedFiles);
      this.reject.emit(rejectedFiles);
    }
    onRemove(file) {
      this.removeHandler() ? this.removeHandler()(file, this) : this.removeFile(file);
    }
    onRemoveRejectedFile(file) {
      this.rejectedFiles.update(rejectedFiles => rejectedFiles.filter(f => f !== file));
      this.onValidatorChange();
    }
    getAcceptedFiles(files) {
      return files.filter(file => !this.rejectedFiles().includes(file)).slice(0, this.maxLength());
    }
    makeRejectedFiles(files) {
      const rejectedFiles = files.slice(this.maxLength()).map(file => {
        return {
          name: file.name,
          size: file.size,
          content: this.rejectionReasons.maxFilesRejectionReason(this.maxLength())
        };
      });
      this.updateFiles(rejectedFiles);
    }
    static {
      this.ɵfac = function FileInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FileInputComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FileInputComponent,
        selectors: [["assets-file-input"]],
        inputs: {
          title: [1, "title"],
          accept: [1, "accept"],
          downloadable: [1, "downloadable"],
          editable: [1, "editable"],
          isRequired: [1, "isRequired"],
          loading: [1, "loading"],
          multiple: [1, "multiple"],
          maxFileSize: [1, "maxFileSize"],
          maxLength: [1, "maxLength"],
          maxVisible: [1, "maxVisible"],
          mode: [1, "mode"],
          size: [1, "size"],
          subtitle: [1, "subtitle"],
          subtitleTpl: [1, "subtitleTpl"],
          removeHandler: [1, "removeHandler"]
        },
        outputs: {
          reject: "reject"
        },
        features: [i0.ɵɵProvidersFeature([provideFormControl(FileInputComponent), provideControlValidator(FileInputComponent)])],
        ngContentSelectors: _c0,
        decls: 18,
        vars: 15,
        consts: [["validator", "tuiInputFilesValidator"], [1, "uploader"], [1, "uploader__wrapper", "wrapper"], [1, "wrapper__header"], [1, "wrapper__title"], [1, "wrapper__subtitle", "assets-text-body-l"], ["ngProjectAs", "file-input", 5, ["file-input"], 1, "uploader__input", "input"], ["tuiInputFiles", "", 1, "input__label"], ["tuiInputFiles", "", 3, "blur", "ngModelChange", "reject", "accept", "disabled", "maxFileSize", "multiple", "ngModel"], [1, "input__files", 3, "max"], [1, "input__file", "file", 3, "file", "showDelete", "state"], ["showDelete", "always", "state", "error", 1, "input__file", 3, "file"], [4, "ngTemplateOutlet"], ["class", "input__file file", 3, "file", "showDelete", "state", "remove", 4, "tuiItem"], [1, "input__file", "file", 3, "remove", "file", "showDelete", "state"], ["appearance", "gray-flat", "data-locator", "Download", "size", "xs", "tuiIconButton", "", "type", "button", 1, "file__download", 3, "ngDownload", "ngDownloadName", "ngDownloadType"], ["icon", "download", 3, "size"], ["showDelete", "always", "state", "error", "class", "input__file", 3, "file", "remove", 4, "tuiItem"], ["showDelete", "always", "state", "error", 1, "input__file", 3, "remove", "file"]],
        template: function FileInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "h6", 4);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div");
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(7, FileInputComponent_Conditional_7_Template, 3, 1, "ng-container");
            i0.ɵɵconditionalCreate(8, FileInputComponent_Conditional_8_Template, 2, 1, "p", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 6)(10, "label", 7)(11, "input", 8, 0);
            i0.ɵɵlistener("blur", function FileInputComponent_Template_input_blur_11_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onTouched());
            })("ngModelChange", function FileInputComponent_Template_input_ngModelChange_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFileChange($event));
            })("reject", function FileInputComponent_Template_input_reject_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onReject($event));
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "tui-files", 9);
            i0.ɵɵrepeaterCreate(14, FileInputComponent_For_15_Template, 1, 0, "tui-file", 10, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵrepeaterCreate(16, FileInputComponent_For_17_Template, 1, 0, "tui-file", 11, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵattribute("data-mode", ctx.mode())("data-size", ctx.size());
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.title());
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.subtitle() ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.subtitleTpl() ? 8 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("disabled", ctx.disabled())("hidden", ctx.isInputHidden());
            i0.ɵɵadvance();
            i0.ɵɵproperty("accept", ctx.accept())("disabled", ctx.disabled())("maxFileSize", ctx.maxFileSize())("multiple", ctx.multiple())("ngModel", ctx.files());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("max", ctx.maxVisible());
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.files());
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.rejectedFiles());
          }
        },
        dependencies: [i1.AsyncPipe, i4.ConditionPipe, i3.DownloadDirective, i4$1.FormsModule, i4$1.DefaultValueAccessor, i4$1.NgControlStatus, i4$1.NgModel, IconComponent, i4.MapPipe, i1$1.TuiButton, i1.NgTemplateOutlet, i7.TuiItem, i8.TuiFile, i8.TuiInputFiles, i8.TuiFilesComponent, i8.TuiFileRejectedPipe, i8.TuiInputFilesDirective],
        styles: [".wrapper[_ngcontent-%COMP%]{display:flex;gap:var(--gap);flex-direction:column}.wrapper[data-mode=outlined][_ngcontent-%COMP%]{padding:16px;border:1px solid var(--assets-base-05);border-radius:6px}.wrapper[data-size=m][_ngcontent-%COMP%]{--gap: 16px;--title-font-weight: 800;--title-font-size: 20px;--title-line-height: 22px;--title-min-height: 32px;--subtitle-font-size: 16px;--subtitle-line-height: 22.4px}.wrapper[data-size=s][_ngcontent-%COMP%]{--gap: 8px;--title-font-weight: 700;--title-font-size: 16px;--title-line-height: 22.4px;--title-min-height: 24px;--subtitle-font-size: 14px;--subtitle-line-height: 18.2px}.wrapper__header[_ngcontent-%COMP%]{display:grid;gap:8px;grid-template-columns:1fr auto}.wrapper__title[_ngcontent-%COMP%]{font-family:var(--assets-font-family-archivo);font-size:var(--title-font-size);font-weight:var(--title-font-weight);line-height:var(--title-line-height);min-height:var(--title-min-height)}.wrapper__subtitle[_ngcontent-%COMP%]{grid-column:span 2;font-weight:400;color:var(--assets-text-02);font-size:var(--subtitle-font-size);line-height:var(--subtitle-line-height);white-space:pre-line}.input[_ngcontent-%COMP%]{display:flex;flex-direction:column}.input__label[_ngcontent-%COMP%]:not(.hidden) + .input__files[_ngcontent-%COMP%]:has(*){margin-top:4px}.file[_ngcontent-%COMP%]{position:relative}.file__download[_ngcontent-%COMP%]{position:absolute;z-index:1;right:10px;width:24px;color:var(--assets-text-02)}"],
        changeDetection: 0
      });
    }
  }
  return FileInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoaderComponent = /*#__PURE__*/(() => {
  class LoaderComponent {
    static {
      this.ɵfac = function LoaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoaderComponent,
        selectors: [["assets-loader"]],
        decls: 5,
        vars: 0,
        consts: [[1, "loader"]],
        template: function LoaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div")(2, "div")(3, "div")(4, "div");
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [CommonModule],
        styles: [".loader[_ngcontent-%COMP%]{display:flex;gap:6px;align-items:center;justify-content:center;height:35px}.loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{width:16px;height:16px;animation:_ngcontent-%COMP%_anim 1s infinite linear;animation-delay:calc(-.3s * var(--i))}.loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:first-child{--i: 1;background-color:var(--assets-loader-primary, var(--assets-primary));border-radius:0 50% 0 0}.loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(2){--i: 2;background-color:var(--assets-loader-accent, var(--assets-accent));border-radius:50%}.loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(3){--i: 3;background-color:var(--assets-loader-primary, var(--assets-primary));border-radius:50% 0 0 50%}.loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:last-child{--i: 4;background-color:var(--assets-loader-primary, var(--assets-primary));border-radius:50% 50% 0 0}@keyframes _ngcontent-%COMP%_anim{0%,to{transform:translateY(5px)}50%{transform:translateY(-10px)}}"],
        changeDetection: 0
      });
    }
  }
  return LoaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NotificationImports = [TuiNotification, IconComponent, TuiButton];
let NotificationComponent = /*#__PURE__*/(() => {
  class NotificationComponent {
    constructor() {
      this.appearance = input('info');
      this.icon = input('info');
      this.iconSize = input(16);
      this.closeable = input(false);
      this.onClose = output();
    }
    onCloseClick(event) {
      this.onClose.emit(event);
    }
    static {
      this.ɵfac = function NotificationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotificationComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NotificationComponent,
        selectors: [["assets-notification"]],
        inputs: {
          appearance: [1, "appearance"],
          icon: [1, "icon"],
          iconSize: [1, "iconSize"],
          closeable: [1, "closeable"]
        },
        outputs: {
          onClose: "onClose"
        },
        ngContentSelectors: _c2,
        decls: 11,
        vars: 3,
        consts: [["icon", "", 3, "appearance"], [1, "icon-left", 3, "icon", "size"], [1, "wrapper"], [1, "content"], [1, "title"], [1, "info"], [1, "additional-content"], ["appearance", "flat-tertiary", "tuiIconButton", "", "type", "button", 1, "close"], ["appearance", "flat-tertiary", "tuiIconButton", "", "type", "button", 1, "close", 3, "click"], ["icon", "close", 3, "size"]],
        template: function NotificationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵelementStart(0, "tui-notification", 0);
            i0.ɵɵconditionalCreate(1, NotificationComponent_Conditional_1_Template, 1, 2, "assets-icon", 1);
            i0.ɵɵelementStart(2, "section", 2)(3, "div", 3)(4, "div", 4);
            i0.ɵɵprojection(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 5);
            i0.ɵɵprojection(7, 1);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 6);
            i0.ɵɵprojection(9, 2);
            i0.ɵɵelementEnd()();
            i0.ɵɵconditionalCreate(10, NotificationComponent_Conditional_10_Template, 2, 1, "button", 7);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("appearance", ctx.appearance());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.icon() ? 1 : -1);
            i0.ɵɵadvance(9);
            i0.ɵɵconditional(ctx.closeable() ? 10 : -1);
          }
        },
        dependencies: [i1$1.TuiNotification, IconComponent, i1$1.TuiButton],
        styles: [":is(.title[_ngcontent-%COMP%], .info[_ngcontent-%COMP%], .additional-content[_ngcontent-%COMP%]):is([_ngcontent-%COMP%]:empty){display:none}"],
        changeDetection: 0
      });
    }
  }
  return NotificationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ProgressBarImports = [...TuiProgress];
let ProgressBarComponent = /*#__PURE__*/(() => {
  class ProgressBarComponent {
    constructor() {
      this.size = input('m');
      this.value = input.required();
      this.segments = input(null);
      this.max = input(null);
      this.appearance = input(null);
    }
    static {
      this.ɵfac = function ProgressBarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProgressBarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProgressBarComponent,
        selectors: [["assets-progress"]],
        inputs: {
          size: [1, "size"],
          value: [1, "value"],
          segments: [1, "segments"],
          max: [1, "max"],
          appearance: [1, "appearance"]
        },
        ngContentSelectors: _c4,
        decls: 14,
        vars: 5,
        consts: [[1, "progress-bar"], [1, "top-content"], [1, "left-label"], [1, "right-label"], ["tuiProgressBar", "", 3, "max", "segments", "value", "size"], [1, "bottom-content"], [1, "mid-label"]],
        template: function ProgressBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c3);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 3);
            i0.ɵɵprojection(5, 1);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(6, "progress", 4);
            i0.ɵɵelementStart(7, "div", 5)(8, "div", 2);
            i0.ɵɵprojection(9, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 6);
            i0.ɵɵprojection(11, 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "div", 3);
            i0.ɵɵprojection(13, 4);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("max", ctx.max())("segments", ctx.segments())("value", ctx.value())("size", ctx.size());
            i0.ɵɵattribute("data-appearance", ctx.appearance());
          }
        },
        dependencies: [i8.TuiProgressBar, i8.TuiProgressSegmented],
        styles: [".progress-bar[_ngcontent-%COMP%]   .top-content[_ngcontent-%COMP%], .progress-bar[_ngcontent-%COMP%]   .bottom-content[_ngcontent-%COMP%]{display:flex;align-items:center;font:var(--assets-font-text-m)}.progress-bar[_ngcontent-%COMP%]   .left-label[_ngcontent-%COMP%]{margin-right:auto}.progress-bar[_ngcontent-%COMP%]   .right-label[_ngcontent-%COMP%]{margin-left:auto}.progress-bar[_ngcontent-%COMP%]   .mid-label[_ngcontent-%COMP%]{margin:0 auto}.progress-bar[_ngcontent-%COMP%]   .top-content[_ngcontent-%COMP%]:not(:empty){margin-bottom:8px}.progress-bar[_ngcontent-%COMP%]   .bottom-content[_ngcontent-%COMP%]:not(:empty){margin-top:8px}.progress-bar[_ngcontent-%COMP%]   [tuiProgressBar][_ngcontent-%COMP%]{color:var(--assets-primary);border-radius:20px;background:var(--assets-base-04)}.progress-bar[_ngcontent-%COMP%]   [tuiProgressBar]._segmented[_ngcontent-%COMP%]{--tui-segment-gap: 8px;-webkit-mask-image:radial-gradient(circle closest-side at calc(var(--t-height) / 2) center,#999 0 99%,transparent 100% 100%),radial-gradient(circle closest-side at calc(100% - var(--t-height) / 2 - var(--tui-segment-gap)) center,#999 0 99%,transparent 100% 100%),linear-gradient(to right,transparent 0 calc(var(--t-height) / 2),#999 calc(var(--t-height) / 2) calc(100% - var(--t-height) / 2 - var(--tui-segment-gap)),transparent calc(100% - var(--t-height) / 2 - var(--tui-segment-gap)));mask-image:radial-gradient(circle closest-side at calc(var(--t-height) / 2) center,#999 0 99%,transparent 100% 100%),radial-gradient(circle closest-side at calc(100% - var(--t-height) / 2 - var(--tui-segment-gap)) center,#999 0 99%,transparent 100% 100%),linear-gradient(to right,transparent 0 calc(var(--t-height) / 2),#999 calc(var(--t-height) / 2) calc(100% - var(--t-height) / 2 - var(--tui-segment-gap)),transparent calc(100% - var(--t-height) / 2 - var(--tui-segment-gap)))}.progress-bar[_ngcontent-%COMP%]   [tuiProgressBar][data-appearance=no-round][_ngcontent-%COMP%]{border-radius:0}.progress-bar[_ngcontent-%COMP%]   [tuiProgressBar][data-appearance=no-round]._segmented[_ngcontent-%COMP%]{--tui-segment-gap: 4px;-webkit-mask-image:linear-gradient(to left,transparent 0 var(--tui-segment-gap),#999 var(--tui-segment-gap) 100%);mask-image:linear-gradient(to left,transparent 0 var(--tui-segment-gap),#999 var(--tui-segment-gap) 100%)}.progress-bar[_ngcontent-%COMP%]   [tuiProgressBar][data-size=l][_ngcontent-%COMP%]{--t-height: 12px}.progress-bar[_ngcontent-%COMP%]   [tuiProgressBar][data-size=m][_ngcontent-%COMP%]{--t-height: 8px}.progress-bar[_ngcontent-%COMP%]   [tuiProgressBar][data-size=s][_ngcontent-%COMP%]{--t-height: 4px}"],
        changeDetection: 0
      });
    }
  }
  return ProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SliderWrapperImports = [RangePipe, MapPipe, TuiButton, NgTemplateOutlet];
class SliderWrapperComponent {
  constructor() {
    this.$slider = contentChild(TuiSliderComponent);
    this.ngControl = contentChild(NgControl);
    this.stepLabelFn = input(this.defaultStepLabelFn);
    this.stepLabelSuffix = input('');
    this.useButtons = input(false);
    this.showLabels = input(null);
    this.rangeValue = computed(() => this.$slider().max - this.$slider().min);
    this.labelsSize = computed(() => {
      return Math.ceil((this.rangeValue() + 1) / this.$slider()['step']);
    });
    this.isControlDisabled = computed(() => this.ngControl().disabled);
    this.decreaseContext = {
      icon: '@tui.minus',
      actionType: 'decrease'
    };
    this.increaseContext = {
      icon: '@tui.plus',
      actionType: 'increase'
    };
  }
  defaultStepLabelFn(stepIndex) {
    return `${this.calculateValue(stepIndex)}${this.stepLabelSuffix()}`;
  }
  get value() {
    return this.ngControl().value ?? 0;
  }
  setValue(value) {
    const {
      min,
      max
    } = this.$slider();
    this.ngControl().control.setValue(tuiClamp(value, min, max));
  }
  changeValue(actionType) {
    const newValue = actionType === 'increase' ? this.value + this.$slider()['step'] : this.value - this.$slider()['step'];
    this.setValue(newValue);
  }
  calculateValue(stepIndex) {
    return this.$slider().min + stepIndex * this.$slider()['step'];
  }
  setValueByIndex(index) {
    const value = this.calculateValue(index);
    this.setValue(value);
  }
  static {
    this.ɵfac = function SliderWrapperComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SliderWrapperComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SliderWrapperComponent,
      selectors: [["assets-slider-wrapper"]],
      contentQueries: function SliderWrapperComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.$slider, TuiSliderComponent, 5);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.ngControl, NgControl, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(2);
        }
      },
      inputs: {
        stepLabelFn: [1, "stepLabelFn"],
        stepLabelSuffix: [1, "stepLabelSuffix"],
        useButtons: [1, "useButtons"],
        showLabels: [1, "showLabels"]
      },
      ngContentSelectors: _c0,
      decls: 8,
      vars: 5,
      consts: [["button", ""], [1, "slider"], [1, "slider__input-wrapper"], [1, "ticks-labels"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["type", "button", 1, "tick-label", 3, "disabled"], ["type", "button", 1, "tick-label", 3, "click", "disabled"], ["appearance", "gray-flat", "size", "xs", "tuiIconButton", "", "type", "button", 1, "action-btn", 3, "click", "disabled", "iconStart"]],
      template: function SliderWrapperComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵconditionalCreate(1, SliderWrapperComponent_Conditional_1_Template, 1, 2, "ng-container");
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵprojection(3);
          i0.ɵɵconditionalCreate(4, SliderWrapperComponent_Conditional_4_Template, 4, 3, "div", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵconditionalCreate(5, SliderWrapperComponent_Conditional_5_Template, 1, 2, "ng-container");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, SliderWrapperComponent_ng_template_6_Template, 1, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵclassProp("with-buttons", ctx.useButtons());
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.useButtons() ? 1 : -1);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.showLabels() ? 4 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.useButtons() ? 5 : -1);
        }
      },
      dependencies: [i4.RangePipe, i4.MapPipe, i1$1.TuiButton, i1.NgTemplateOutlet],
      styles: [".slider[_ngcontent-%COMP%]{display:flex;gap:16px;align-items:start}.slider__input-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:2px;width:100%}.slider[_ngcontent-%COMP%]     [tuiSlider]:after{content:\"\";position:absolute;top:50%;left:0;width:calc(var(--tui-slider-fill-ratio) * 100%);height:2px;background:var(--assets-primary);z-index:1;transform:translateY(-50%);border-radius:6px}.slider.with-buttons[_ngcontent-%COMP%]   .slider__input-wrapper[_ngcontent-%COMP%]{padding-top:6px}.slider[_ngcontent-%COMP%]   .tick-label[_ngcontent-%COMP%]{font:var(--assets-font-text-s);color:var(--assets-text-01);background-color:transparent}.slider[_ngcontent-%COMP%]   .action-btn[_ngcontent-%COMP%]{--assets-btn-icon-size-xs: 24px;padding-inline:0!important;border:0;color:var(--assets-text-03)}.slider[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:disabled{opacity:50%;color:var(--assets-text-03)!important}"],
      changeDetection: 0
    });
  }
}
__decorate([Bind()], SliderWrapperComponent.prototype, "defaultStepLabelFn", null);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TagImports = [TuiChip, IconComponent];
let TagComponent = /*#__PURE__*/(() => {
  class TagComponent {
    constructor() {
      this.text = input.required();
      this.size = input('m');
      this.icon = input(null);
      this.appearance = input('neutral');
      this.onClick = output();
    }
    onClickEmitter(event) {
      this.onClick.emit(event);
    }
    static {
      this.ɵfac = function TagComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TagComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TagComponent,
        selectors: [["assets-tag"]],
        inputs: {
          text: [1, "text"],
          size: [1, "size"],
          icon: [1, "icon"],
          appearance: [1, "appearance"]
        },
        outputs: {
          onClick: "onClick"
        },
        decls: 3,
        vars: 4,
        consts: [[1, "tag", 3, "appearance", "size"], ["type", "button", 1, "close"], ["type", "button", 1, "close", 3, "click"], [3, "icon", "size"]],
        template: function TagComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "tui-chip", 0);
            i0.ɵɵtext(1);
            i0.ɵɵconditionalCreate(2, TagComponent_Conditional_2_Template, 2, 2, "button", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("appearance", ctx.appearance())("size", ctx.size());
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.text(), " ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.icon() ? 2 : -1);
          }
        },
        dependencies: [i8.TuiChip, IconComponent],
        styles: [".tag[_ngcontent-%COMP%]:has(.close:hover){background-color:#ccc}.tag[_ngcontent-%COMP%]:has(.close:active){background-color:#ccc}.tag[data-appearance=neutral][_ngcontent-%COMP%]:has(.close:hover){background-color:var(--assets-clear-hover)}.tag[data-appearance=neutral][_ngcontent-%COMP%]:has(.close:active){background-color:var(--assets-clear-active)}.tag[data-appearance=primary][_ngcontent-%COMP%]:has(.close:hover){background-color:var(--assets-primary-hover)}.tag[data-appearance=primary][_ngcontent-%COMP%]:has(.close:active){background-color:var(--assets-primary-active)}"],
        changeDetection: 0
      });
    }
  }
  return TagComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const imports = [IconComponent, LoaderComponent, BadgeComponent, DropdownItemComponent, ChipComponent, TagComponent, FileInputComponent, NotificationComponent, ProgressBarComponent, SliderWrapperComponent];
let AssetsComponentsModule = /*#__PURE__*/(() => {
  class AssetsComponentsModule {
    static {
      this.ɵfac = function AssetsComponentsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AssetsComponentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AssetsComponentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [LoaderComponent, BadgeComponent, DropdownItemComponent, ChipComponent, FileInputComponent, ProgressBarComponent]
      });
    }
  }
  return AssetsComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AssetsComponentsModule, BadgeComponent, ChipComponent, DropdownItemComponent, FILE_REJECTION_REASONS, FileInputComponent, IconComponent, LoaderComponent, NotificationComponent, ProgressBarComponent, SliderWrapperComponent, TagComponent };
